import logo from './logo.svg';
import './App.css';
import Banner from './component/banner/banner';
import Timeline from './component/timeline/timeline';
import Categories from './component/categories/categories';
import DefaultRow from './component/layout/defalutRow/defalutRow';
import Enter from './component/enter/enter';
import Prizes from './component/section/prizes/prizes';
import Nav from './component/nav/nav';
import Terms from './component/section/terms/terms';
import Apply from './component/section/apply/apply';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useEffect } from 'react';
gsap.registerPlugin(ScrollTrigger);

function App() {
  useEffect(() => {
    window.addEventListener('load', () => {
      document
        .querySelectorAll('.sm5-active-fade-in-element')
        .forEach((item) => {
          gsap.fromTo(
            item,
            {
              opacity: 0,
              y: 80,
            },
            {
              opacity: 1,
              y: 0,
              duration: 0.6,
              scrollTrigger: {
                trigger: item,
                start: 'top bottom',
              },
            },
          );
        });
    });
  });
  return (
    <>
      <Nav />
      <Banner />
      <Timeline />

      <Categories />

      <Enter />

      <Prizes />

      <Terms />

      <Apply />
    </>
  );
}

export default App;
